export let homeNavList = [
  {
    path: '/about',
    name: '关于威马捷',
    id: 1
  }, {
    path: '/internationalIndex',
    name: '海外医疗',
    id: 2
  }, {
    path: '/rescue',
    name: '全球救援',
    id: 3,
    childList: [{
      title: '保险客户',
      path: '/rescueOfEmergencyInChina',
      name: '在华紧急医疗救援服务'
    }, {
      path: '/rescueOfOverseasService',
      name: '境外紧急医疗救援服务'
    }, {
      path: '/rescueOfOtherService',
      name: '其它旅行援助服务'
    }, {
      title: '企业客户',
      path: '/rescueOfMemberService',
      name: '法人会员服务'
    }, {
      path: '/rescueOfPersonalized',
      name: '定制救援服务'
    }, {
      title: '个人客户',
      path: '/rescueOfIndividualCase',
      name: '紧急医疗救援服务'
    }]
  }, {
    path: '/companyInfotion',
    name: '公司信息',
    id: 4
  }, {
    path: '/recruitment',
    name: '招聘信息',
    id: 5
  },
]
export let overseasNavList = [
  {
    path: '/internationalIndex',
    name: '海外医疗首页'
  }, {
    path: '/internationalMedicine',
    name: '出国看病',
    childList: [{
      path: '/hospitalList/fwlx/1',
      name: '日本'
    }, {
      path: '/hospitalList/fwlx/8',
      name: '瑞士'
    }, {
      path: '/hospitalList/fwlx/3',
      name: '德国'
    }, {
      path: '/hospitalList/fwlx/9',
      name: '新加坡'
    }, {
      path: '/hospitalList/fwlx/4',
      name: '意大利'
    }, {
      path: '/hospitalList/fwlx/12',
      name: '美国'
    }]
  }, {
    path: '/internationalBodyCheck',
    name: '精密体检',
    childList: [{
      path: '/hospitalList/jmtj/1',
      name: '日本'
    }, {
      path: '/hospitalList/jmtj/8',
      name: '瑞士'
    }, {
      path: '/hospitalList/jmtj/3',
      name: '德国'
    }, {
      path: '/hospitalList/jmtj/9',
      name: '新加坡'
    }, {
      path: '/hospitalList/jmtj/4',
      name: '意大利'
    }, {
      path: '/hospitalList/jmtj/12',
      name: '美国'
    }]
  }, {
    path: '/internationalConsultation',
    name: '远程咨询'
  }, {
    path: '/internationalAntiAging',
    name: '辅助生殖'
  }, {
    path: '/internationalAdvanced',
    name: '先进医疗'
  }, {
    path: '/internationalDisease',
    name: '疾病专题'
  }, {
    path: '/doctorList/0',
    name: '权威专家'
  }, {
    path: '/successCase/0',
    name: '服务案例'
  }
]